import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';

const convertToDataTable = (data: IGetDropdownData[]): IGetDropdownData[] => {
  const dataTableData: IGetDropdownData[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllGpsNumbers =  async (unitid:number | undefined): Promise<IGetDropdownData[]> => {
  const  response = await axiosDefaultApi.get(`/api/Atm/GetGps` );
  return convertToDataTable(response as unknown as IGetDropdownData[]);
};

type QueryFnType = typeof getAllGpsNumbers;

type UseGetAllGpsNumbersOptions = {
  unitid:number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllGpsNumbers = ({ config, unitid }: UseGetAllGpsNumbersOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllGpsNumbers'],
    queryFn: () => getAllGpsNumbers(unitid),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};